import React, { useState } from "react";
import {
  EllipsisVerticalIcon,
  EnvelopeIcon,
  PhoneIcon,
  IdentificationIcon,
  BriefcaseIcon,
} from "@heroicons/react/16/solid";
import { message, Popconfirm } from "antd";
import EditEmpForm from "./EditEmpForm";
import { UserOutlined } from "@ant-design/icons";
import UserImg from '../../assets/user.png';

const EmpCard = ({ emp, desigOpt, deptOpt, skillData }) => {
  const [editModal, setEditModal] = useState(false);
  // console.log("EmpCard:", emp)
  const confirm = () => {
    // console.log("Editing employee:", emp);
    setEditModal(true);
  };

  // const cancel = () => {
  //   // console.log("Delete action cancelled for employee:", emp);
  //   message.error("Delete cancelled");
  // };

  return (
    <div className="bg-[#FFFFFF] p-6 shadow-[0_4px_12px_-5px_rgba(0,0,0,0.4)] w-full max-w-sm rounded-2xl font-[sans-serif] mt-4">
      <div className="flex justify-end">
        <Popconfirm
          onConfirm={confirm}
          // onCancel={cancel}
          icon=""
          placement="rightBottom"
          okText="Edit"
          // cancelText="Delete"
        >
          <EllipsisVerticalIcon className="h-6 w-6 text-gray-500" />
        </Popconfirm>
      </div>

      <div className="flex flex-col items-center">
        <div className="min-h-[110px]">
          <img
            // src={`data:image/jpeg;base64,${emp.IMAGE}`}
            src={emp?.IMAGEURL || UserImg}
            className="w-28 h-28 rounded-full object-fit"
            alt="Employee"
          />
        </div>
        <div className="mt-4 text-center">
          <p className="text-lg text-gray-800 font-bold">{emp?.FIRSTNAME}</p>
          <p className="text-sm font-bold text-gray-500 mt-1">
            {emp?.DESIG_TITLE || "-"}
          </p>
        </div>
      </div>

      <div className="bg-[#F2F7FA] border-gray-200 border-2 p-4 rounded-md space-y-3">
        <div className="flex items-center space-x-2">
          <IdentificationIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-800 font-medium text-sm">
            {emp?.DEPT_TITLE || "-"}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <BriefcaseIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-800 font-medium text-sm">
            {emp?.QUAL_TITLE || "-"}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <IdentificationIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-800 font-medium text-sm">
            {emp?.JOININGDATE
              ? new Date(emp.JOININGDATE).toLocaleDateString("en-GB")
              : "N/A"}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <EnvelopeIcon className="h-6 w-6 text-gray-500" />
          <span className="text-blue-500 bg-white border-2 rounded-xl p-0.5 font-thin text-sm">
            {emp?.EMAIL || "N/A"}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <PhoneIcon className="h-6 w-6 text-gray-500" />
          <span className="text-blue-500 bg-white border-2 rounded-xl p-0.5 font-semibold text-sm">
            {emp?.PHONE || "N/A"}
          </span>
        </div>
      </div>

      <EditEmpForm
        visible={editModal}
        onClose={() => setEditModal(false)}
        empData={emp}
        desigOpt={desigOpt}
        deptOpt={deptOpt}
        skillData={skillData}
      />
    </div>
  );
};

export default EmpCard;
